import { TRAILER_12, TRAILER_8 } from "./dimensions";
import { Trailer12Body, Trailer8Body } from "./TrailerBody";
import { TRAILER_12_LAYOUT, TRAILER_12_WHEELS, TRAILER_8_LAYOUT, TRAILER_8_WHEELS } from "./wheels";
const trailer12Preset = {
  id: "trailer-12",
  silhouette: "trailer",
  renderModelKey: "trailer",
  renderLayoutKey: "trailer-12-wheel-v1",
  label: "3 axles, all dual, no steer axle",
  layout: TRAILER_12_LAYOUT,
  wheels: TRAILER_12_WHEELS,
  camera: {
    position: [12.9, 5.5, 11.3],
    target: [0, 1.85, 0],
    minDistance: 10,
    maxDistance: 42,
    fov: 32
  },
  stage: { extent: TRAILER_12.length, contactHeight: 1.5 },
  skeleton: "axles",
  Body: Trailer12Body
};
const trailer8Preset = {
  id: "trailer-8",
  silhouette: "trailer",
  renderModelKey: "trailer",
  renderLayoutKey: "trailer-8-wheel-v1",
  label: "2 axles, all dual, no steer axle",
  layout: TRAILER_8_LAYOUT,
  wheels: TRAILER_8_WHEELS,
  camera: {
    position: [11.2, 5, 9.8],
    target: [0, 1.85, 0],
    minDistance: 8,
    maxDistance: 34,
    fov: 32
  },
  stage: { extent: TRAILER_8.length, contactHeight: 1.5 },
  skeleton: "axles",
  Body: Trailer8Body
};
export {
  trailer12Preset,
  trailer8Preset
};
